import { UiEffects } from './ui.effects'
import { UI_FACADE, UiFacade } from './ui.facade'
import { uiState } from './ui.reducer'
import { uiFeatureKey } from './ui.state'

export * from './ui.facade'

export const UI_REDUCER = { [uiFeatureKey]: uiState }
export const UI_PROVIDERS = [{ provide: UI_FACADE, useClass: UiFacade }]
export const UI_EFFECTS = [UiEffects]
